import * as React from 'react';

export const PandoraIsologo: React.FC<React.SVGProps<SVGSVGElement>> = (
  props
) => (
  <svg width="14" height="16" viewBox="0 0 14 16" {...props}>
    <path d="M14 5.4C13.7 2.4 11 0 7.8 0H0v16h4c0.6 0 1-0.4 1-1v-3h3c1.7 0 3.3-0.7 4.4-2C13.6 8.8 14.1 7.1 14 5.4z" />
  </svg>
);

export default PandoraIsologo;
